import { isKalamaBrandingEnabled } from 'src/modules/brand/utils/kalama-branding'
import { Typography } from 'src/modules/core/components/typography'
import type { ConfirmationMarketingLinkProps } from './confirmation-marketing-link.interface'

const MARKETING_URL =
  'https://www.smsreminder.app/?utm_source=Confirmation+Page&utm_medium=web&utm_campaign=Appt+Confirmations'
const SMS_REMINDER_LOGO = { src: '/logo.png', alt: 'SMS Reminder for Google Calendar™' }
const KALAMA_LOGO = { src: '/favicon-kalama-120.png', alt: 'Kalama (formerly SMS Reminder)' }

export function ConfirmationMarketingLink({ classes }: ConfirmationMarketingLinkProps) {
  const logo = isKalamaBrandingEnabled() ? KALAMA_LOGO : SMS_REMINDER_LOGO

  return (
    <div className={classes.marketingLink}>
      <a href={MARKETING_URL} target="_blank" rel="noopener noreferrer">
        <img src={logo.src} alt={logo.alt} className={classes.marketingLinkLogo} />
        <Typography variant="body" className={classes.marketingLinkText}>
          Click here to send your own SMS appointment reminders
        </Typography>
      </a>
    </div>
  )
}
